// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/hero-banner-item-full/hero-banner-item-full.component.scss
// module id = 358
// module chunks = 0